<template>
  <div>
    <b-loading :active.sync="isLoadingPage"></b-loading>

    <div class="level is-marginless is-hidden-mobile">
      <div class="level-left"></div>
      <div class="level-right"></div>
    </div>
    <div class="columns is-margin-x-not head-table is-hidden-mobile">
      <div class="column is-8 has-text-centered" @click="sortBy('name')">
        <p
          class="is-size-6 has-text-weight-semibold cr-pointer"
          :class="{ 'has-text-secondary': currentSort === 'name' }"
        >
          Admin
          <span
            class="arrow"
            :class="currentSortDir === 'asc' ? 'asc' : 'dsc'"
            v-show="currentSort == 'name'"
          ></span>
        </p>
      </div>
      <div class="column is-3 has-text-centered" @click="sortBy('name')">
        <p
          class="is-size-6 has-text-weight-semibold cr-pointer"
          :class="{ 'has-text-secondary': currentSort === 'name' }"
        >
          Projects
          <span
            class="arrow"
            :class="currentSortDir === 'asc' ? 'asc' : 'dsc'"
            v-show="currentSort == 'name'"
          ></span>
        </p>
      </div>
    </div>
    <div
      v-if="adminData.length == 0"
      class="is-detail-list detail-table mg-y-15"
    >
      <p class="has-text-drak is-size-4 th is-padding-x-s is-margin-top-s">
        ***
      </p>
      <p class="has-text-drak is-size-6 th is-padding-x has-text-centered">
        ขณะนี้ยังไม่มีเจ้าหน้าที่
      </p>
      <p class="has-text-drak is-size-4 th is-padding-x-s is-margin-top-s">
        ***
      </p>
    </div>

    <div class="" v-for="(data, index) in adminData" :key="index" v-else>
      <b-collapse
        :open="false"
        :aria-id="'contentIdForA11y' + index"
        class="detail-table mg-b-35"
      >
        <div
          slot="trigger"
          slot-scope="props"
          role="button"
          class="columns is-margin-x-not is-vcentered m-h-auto box pd-15"
          :class="{
            'hover-border': getRule == 'exclusiveboard' ? true : false,
            'hover-border-board': getRule == 'board' ? true : false,
          }"
          :aria-controls="'contentIdForA11y' + index"
        >
          <div class="column is-8 is-paddingless" data-label="name">
            <div
              v-if="widthMax > 768"
              class="is-align-center is-justify-center is-flex-large is-flex-row is-hidden-mobile"
            >
              <div class="column is-1">
                <div class="mg-x-10">
                  <div
                    class="border-radius"
                    :class="{
                      active: props.open,
                      'hover-border':
                        getRule == 'exclusiveboard' ? true : false,
                      'hover-border-board': getRule == 'board' ? true : false,
                    }"
                    v-show="props.open"
                  >
                    <b-icon pack="fas" :icon="'angle-down'"> </b-icon>
                  </div>
                  <div class="border-radius" v-show="props.open == false">
                    <b-icon pack="fas" icon="angle-up"> </b-icon>
                  </div>
                </div>
              </div>
              <div
                class="column is-2 is-2-fullhd has-text-centered-tablet has-text-right"
              >
                <figure class="image box-circle-logo is-marginless">
                  <img
                    class="is-rounded"
                    v-if="data.profile"
                    @error="
                      $event.target.src =
                        'https://bulma.io/images/placeholders/64x64.png'
                    "
                    :src="imgUrl + data.profile"
                  />
                  <img
                    class=""
                    v-else
                    src="https://bulma.io/images/placeholders/64x64.png"
                    alt="Placeholder image"
                  />
                </figure>
              </div>
              <div class="column is-8 has-text-centered">
                <p class="is-size-6 th">{{ data.organizeName }}</p>
                <p class="is-size-7 th">{{ data.name }} {{ data.surname }}</p>
              </div>
            </div>
            <div
              v-if="widthMax < 768"
              class="is-align-center is-justify-center is-flex is-flex-column is-hidden-tablet"
            >
              <div class="column is-5 has-text-centered pd-col-fixed">
                <figure class="image box-circle-s">
                  <img
                    class="is-rounded"
                    @error="
                      $event.target.src =
                        'https://bulma.io/images/placeholders/64x64.png'
                    "
                    v-if="data.profile"
                    :src="imgUrl + data.profile"
                  />
                  <img
                    class="is-rounded"
                    v-else
                    src="https://bulma.io/images/placeholders/64x64.png"
                    alt="Placeholder image"
                  />
                </figure>
              </div>
              <div class="column is-1 has-text-centered pd-col-fixed">
                <p class="is-size-6 th">{{ data.organizeName }}</p>
                <p class="is-size-7 th">{{ data.name }} {{ data.surname }}</p>
              </div>
            </div>
          </div>
          <div
            class="column is-3 is-paddingless has-text-centered th"
            data-label="Batch"
          >
            {{ data.batchs.length }} โครงการ
          </div>
        </div>
        <div class="card-content" v-if="data.batchs.length > 0">
          <div class="is-hidden-mobile">
            <div
              class="columns m-h-auto mg-b-20 has-text-centered has-text-grey-light th"
            >
              <div class="column is-3">
                <p>ชื่อโครงการ</p>
              </div>
              <div class="column is-2">
                <p>ปีงบประมาณ</p>
              </div>
              <div class="column is-3">
                <p>ระดับการวัดผลโครงการ</p>
              </div>
              <div class="column is-3">
                <p>วันที่เริ่มโครงการ</p>
              </div>
            </div>
          </div>
          <div v-for="(item, key) in data.batchs" :key="key">
            <div class="columns m-h-auto has-text-centered th is-size-6">
              <div class="column is-3 is-paddingless">
                <p>{{ item.name }}</p>
              </div>
              <div class="column is-2">
                <p>{{ item.fiscalYear }}</p>
              </div>
              <div class="column is-3">
                <p>{{ getCategoryName(item.levelType) }}</p>
              </div>
              <div class="column is-3">
                <p
                  v-if="
                    typeof item.batchStartDate === 'undefined' ||
                    item.batchStartDate === null ||
                    item.batchStartDate === ''
                  "
                  class="th has-text-grey-light has-text-centered is-hidden-mobile"
                >
                  ** ไม่มีข้อมูล **
                </p>
                <p v-else>{{ startBatchDate(item.batchStartDate) }}</p>
              </div>
              <div
                class="column is-paddingless is-flex is-align-center is-justify-end cr-pointer"
              >
                <span
                  @click="viewDashboard(item, data.adminId)"
                  class="mg-r-20 is-flex is-align-center is-justify-end"
                >
                  <b-icon class="mg-r-5" pack="fas" icon="eye"> </b-icon> View
                </span>
              </div>
            </div>
            <hr />
          </div>
        </div>
      </b-collapse>
    </div>
  </div>
</template>
<script>
import { HTTP } from "../axios.js";
import momentTH from "moment/src/locale/th";
import moment from "moment";

export default {
  data() {
    return {
      render: false,
      activeTab: 0,
      widthMax: window.innerWidth,
      isDeleteStaff: false,
      adminInUnder: [],
      adminNotUnder: [],
      adminData: [],
      imgUrl: process.env.VUE_APP_IMAGE_URL,
      idSelect: 0,
      delStaffName: "",
      countStartUp: 0,
      searchName: null,
      searchLastName: null,
      searchTel: null,
      searchEmail: null,
      allList: [],
      isLoadingPage: true,
      currentSort: "",
      currentSortDir: "asc",
    };
  },
  mounted() {
    this.fetchData();
  },
  computed: {
    levelTypes() {
      return this.$store.state.levelType;
    },
    reportId() {
      return this.$store.state.report;
    },
    user() {
      return this.$store.state.user;
    },
    getRule() {
      return this.$store.state.rule;
    },
    token() {
      return this.$store.state.token;
    },
  },
  methods: {
    startBatchDate(batchDate) {
      //console.log('sadddsadsa',batchDate)
      let res = "";
      if (
        typeof batchDate === "undefined" ||
        batchDate === null ||
        batchDate === ""
      ) {
        res = "";
      } else {
        res = moment(
          moment(batchDate).locale("th", momentTH).add(543, "y")
        ).format("DD MMMM Y ");
      }
      return res;
    },
    getCategoryName(id) {
      let data = this.levelTypes.filter((search) => {
        return search.id == id;
      });
      return data[0].name;
    },
    prevPage() {
      this.$router.push("/department-list");
    },
    viewDashboard(batchId, adminId) {
      this.$store.commit("setDataBatch", batchId);
      // let admin ={
      // 	key:'adminId',
      // 	value:adminId
      // }
      // console.log(admin)
      // this.$store.commit("setDepartmentView", admin);
      let data = {
        key: "adminId",
        value: adminId,
      };
      this.$store.commit("setReportId", data);
      this.$router.push("/board-view-dashboard");
    },
    fetchData() {
      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      let data;
      if (this.getRule == "board") {
        data = {
          scienceParkId: this.user.scienceParkId,
          underId: this.user.under,
        };
      } else {
        data = {
          scienceParkId: this.reportId.scienceParkId,
          underId: this.user.under,
        };
      }
      //console.log(data)
      HTTP.post(`/api/get/all/admin`, data).then((res) => {
        //console.log('api/get/all/board',res)
        if (this.reportId.viewAdmin == "in") {
          this.adminData = res.data.obj.adminInUnder;
        } else {
          let data = [];
          let checkId = [];
          res.data.obj.adminNotUnder.map((value) => {
            if (data.length > 0) {
              checkId = data.filter((search) => {
                return value.adminId == search.adminId;
              });
            }
            //console.log('checkId',checkId)
            if (checkId.length == 0) {
              let filter = res.data.obj.adminNotUnder.filter((search) => {
                return value.adminId == search.adminId;
              });
              //console.log('filter',filter)
              if (filter.length > 1) {
                filter.map((admin, index) => {
                  //console.log('admin',admin)
                  if (index == 0) {
                    data.push(admin);
                  } else {
                    data[0].batchs.push(admin.batchs[0]);
                  }
                  //console.log('data1',data)
                });
              }
            }
            checkId = [];
          });
          //console.log('data2',data)
          this.adminData = data;
        }
        this.isLoadingPage = false;
      });
    },
  },
};
</script>
<style scoped>
.border-radius.active.hover-border-board {
  background-color: #00b2ff;
  border: 1px solid #00b2ff;
  color: #fff;
}
.border-radius.active.hover-border {
  background-color: #ffb82e;
  border: 1px solid #ffb82e;
  color: #fff;
}
.mg-less {
  margin: 0 -1rem !important;
}
.border-radius {
  display: flex;
  border-radius: 50%;
  align-items: center;
  width: 28px;
  justify-content: center;
  color: #e1e1e1;
  border: 2px solid #e1e1e1;
}
.border-radius.active {
  background-color: #02a8a0;
  border: 1px solid #02a8a0;
  color: #fff;
}
.border-radius.active .icon {
  color: #fff;
}
</style>